import { Outlet } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const SLSComponent = () => {
  return (
    <>
      <Helmet>
        <title>Supplier | Admin</title>
      </Helmet>
      <Outlet />
    </>
  );
};

export default SLSComponent;
